import React from 'react';
import styled from 'styled-components';
import { licensedProductRadios } from 'constants/filters';
import { Select } from 'components/styled-primitives';
import { fjSelectTypes, fjSelectWidths } from 'components/primitives';

const SectionTitle = styled.div`
  min-width: 100px;
  font-weight: 400;
  margin-bottom: 8px;
  font-size: 14px;
`;

const Container = styled.div`
  margin-bottom: 16px;
  width: 100%;
  min-width: 130px;
`;

interface ProductSelectorProps {
  value?: string;
  onChange?: (value?: string) => void;
  validator?: () => boolean;
  validatorMessage?: string;
}

const ProductSelector = ({
  value = licensedProductRadios()[0]?.productName || '',
  onChange = () => {},
  validator,
  validatorMessage = '',
}: ProductSelectorProps): React.JSX.Element => {
  const allOptions = licensedProductRadios().map((product) => ({
    label: product.label,
    value: product.productName!,
  }));

  return (
    <Container>
      <SectionTitle>Product Name</SectionTitle>
      <Select
        options={allOptions}
        value={value}
        onChange={(selectedValue?: string) => onChange(selectedValue)}
        type={fjSelectTypes.LG}
        width={fjSelectWidths.FIT}
      />
      {validatorMessage && !validator?.() && (
        <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '4px' }}>
          {validatorMessage}
        </div>
      )}
    </Container>
  );
};

export default ProductSelector;
